import React, { FC } from 'react'

import { Box } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

import Flexbox from '~/components/shared/Flexbox'
import Text, { Title } from '~/components/shared/Text'

import DollarIcon from '~/assets/icons/dollar.svg?sprite'

interface Props {
  title: string
  price: number
  size?: 'small' | 'medium'
  loading?: boolean
  helperText?: string
}

const PackageHeaderCard: FC<Props> = ({
  title,
  price,
  size = 'medium',
  loading,
  helperText
}) => {
  const isSmall = size === 'small'
  const isMedium = size === 'medium'

  return (
    <Box mx={2}>
      <Title mt={0} mb={2} variant="h2" fontSize={26} textAlign="center">
        {loading ? <Skeleton style={{ margin: 'auto' }} width={150} /> : title}
      </Title>
      <Box
        height={(isMedium && 142) || (isSmall && 80)}
        display="flex"
        justifyContent="center"
        alignItems="center"
        borderRadius={4}
      >
        {loading ? (
          <Skeleton variant="rect" width="100%" height="100%" />
        ) : (
          <>
            <Flexbox flexDirection="column" alignItems="center">
              <Flexbox alignItems="center">
                <Box color="text.secondary">
                  <DollarIcon />
                </Box>

                <Title fontSize={(isMedium && 72) || (isSmall && 38)} ml={0.5}>
                  {price}
                </Title>
              </Flexbox>

              {helperText && (
                <Text fontSize={18} mt={-2}>
                  {helperText}
                </Text>
              )}
            </Flexbox>
          </>
        )}
      </Box>
    </Box>
  )
}

export default PackageHeaderCard
